import type { SimulationDetailTO } from '@control-center/control-center-client-public-domain-simulation-ts';
import { managementApi } from 'features/domain-simulation/apiClient';
import { useEffect, useState } from 'react';

const useSimulationDetail = (vin: string | null, pollingIntervalMs?: number) => {
    const [detail, setDetail] = useState<SimulationDetailTO | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [lastUpdatedAt, setLastUpdatedAt] = useState<Date | undefined>(undefined);

    useEffect(() => {
        if (!vin) {
            setDetail(undefined);
            setIsLoading(false);
            setIsError(false);
            return;
        }

        let cancelled = false;

        const fetch = async () => {
            setIsLoading(true);
            try {
                const { data } = await managementApi.getSimulation(vin);
                if (!cancelled) {
                    setIsError(false);
                    setDetail(data);
                    setLastUpdatedAt(new Date());
                }
            } catch (error) {
                console.error(error);
                if (!cancelled) setIsError(true);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };

        fetch();

        if (!pollingIntervalMs)
            return () => {
                cancelled = true;
            };
        const interval = setInterval(fetch, pollingIntervalMs);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [vin, pollingIntervalMs]);

    return { detail, isLoading, isError, lastUpdatedAt };
};

export default useSimulationDetail;
